import { Modal } from '@mantine/core'
import EmailCreateAccount from './EmailCreateAccount'

export default function EmailCreateAccountModal({ opened, onClose, ...props }) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Create Account"
      centered
      {...props}
    >
      <EmailCreateAccount
        onClose={onClose}
      />
    </Modal>
  )
}

